export default "__VITE_ASSET__jdFqt$S2__"